<template>
  <b-card class="shadow" style="min-height: 700px; position: relative;">
    <!-- Overlay de Loading -->
    <div v-if="loading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="mb-0 text-gray-800">
            {{ $t("Monitoramento do Chat Bot") }}
          </h5>

          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i> {{ $t("Filtros") }}
            </b-button>

            <b-button
              variant="success"
              @click="exportarGrid"
            >
              <i class="fas fa-file-excel"></i> Exportar Grid
            </b-button>

            <b-button
              variant="primary"
              @click="exportarConversas"
            >
              <i class="fas fa-download"></i> Exportar Conversas
            </b-button>

          </b-button-group>
        </div>
      </div>

      <!-- FILTROS -->
      <div class="col-12" v-if="viewFilterReport">
        <div class="row">
          <div class="col-md-2">
            <label>Servidor</label>
            <select class="form-control" v-model="filtroServidor" @change="carregarUnidades">
              <option value="">Selecione...</option>
              <option v-for="s in servidores" :key="s.value" :value="s.value">{{ s.text }}</option>
            </select>
          </div>

          <div class="col-md-2">
            <label>Unidade</label>
            <select class="form-control" v-model="filtroUnidade" :disabled="unidades.length === 0" @change="carregarEmails">
              <option value="">Selecione...</option>
              <option v-for="u in unidades" :key="u.value" :value="u.value">{{ u.text }}</option>
            </select>
          </div>

          <div class="col-md-3">
            <label>E-mail Usuário</label>
            <select class="form-control" v-model="filtroEmail" :disabled="emails.length === 0">
              <option value="">Selecione...</option>
              <option v-for="e in emails" :key="e.value" :value="e.value">{{ e.text }}</option>
            </select>
          </div>

          <div class="col-md-2">
            <label>Data inicial</label>
            <input type="date" class="form-control" v-model="filtroDataInicio" :max="dataNow" />
          </div>

          <div class="col-md-2">
            <label>Data final</label>
            <input type="date" class="form-control" v-model="filtroDataFim" :max="dataNow" />
          </div>
        </div>

        <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
          <div class="col-auto px-2 text-right">
            <button
              type="button"
              class="btn btn-secondary"
              @click.prevent="limparFiltros"
            >
              {{ $t("Limpar Filtros") }}
            </button>

            <button
              class="btn btn-success btn-submit"
              type="button"
              @click="getConversas"
            >
              <i class="fas fa-search"></i> {{ $t("Buscar") }}
            </button>
          </div>
        </div>
      </div>

      <!-- TABELA -->
      <div class="col-12 mt-3">
        <b-table
          :fields="campos"
          :items="conversas"
          striped
          hover
          responsive
          small
          outlined
          show-empty
        >
          <template #cell(actions)="data">
            <b-button
              variant="primary"
              size="sm"
              @click="abrirConversa(data.item)"
            >
              <i class="mdi mdi-eye"></i>
            </b-button>
          </template>

          <template #cell(dt_inicio)="data">
            {{ formatarData(data.item.dt_inicio) }}
          </template>

          <template #cell(dt_atendimento)="data">
            {{ formatarData(data.item.dt_atendimento) }}
          </template>

          <template #cell(dt_final)="data">
            {{ formatarData(data.item.dt_final) }}
          </template>

          <template #empty>
            <div class="text-center my-5">
              <img
                alt="Sem registros"
                class="mb-3"
                src="/img/icons/robot.svg"
                style="max-height: 150px"
              />
              <h5>{{ $t("Nenhuma conversa encontrada") }}</h5>
            </div>
          </template>
        </b-table>

        <!-- PAGINAÇÃO -->
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div>
            <select
              class="form-control d-inline-block"
              style="width: 80px"
              v-model="perPage"
              @change="getConversas"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          </div>

          <b-pagination
            v-model="page"
            :per-page="perPage"
            :total-rows="pagination.total"
            @change="getConversas"
          ></b-pagination>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import axios from "axios";
export default {
  name: "MonitoramentoChatBot",
  data() {
    return {
      viewFilterReport: true,
      filtroServidor: null,
      filtroUnidade: null,
      filtroEmail: null,
      filtroDataInicio: null,
      filtroDataFim: null,
      servidores: [],
      unidades: [],
      emails: [],
      conversas: [],
      page: 1,
      perPage: 10,
      pagination: { total: 0 },
      campos: [
        { key: "actions", label: "", thStyle: { width: "70px" } },
        { key: "nome_usuario", label: "Usuário" },
        { key: "dt_inicio", label: "Data da Conversa" },
        { key: "dt_atendimento", label: "Data de Atendimento" },
        { key: "dt_final", label: "Data de Finalização" },
        { key: "nome_unidade", label: "Unidade" },
        { key: "nome_server", label: "Servidor" },
      ],
      loading: false,
    };
  },
  computed: {
    dataNow() {
      return new Date().toISOString().split("T")[0];
    },
  },
  methods: {
    viewFilters() {
      this.viewFilterReport = !this.viewFilterReport;
    },
    limparFiltros() {
      this.filtroServidor = null;
      this.filtroUnidade = null;
      this.filtroEmail = null;
      this.filtroDataInicio = null;
      this.filtroDataFim = null;
      this.unidades = [];
      this.emails = [];
      this.getConversas();
    },

    async carregarServidores() {
      this.loading = true;
      try {
        const { data } = await axios.get("/api/dashboard/botpress/servidores");
        this.servidores = data.map((s) => ({ value: s, text: s }));
      } catch (err) {
        console.error("Erro ao carregar servidores:", err);
      } finally {
        this.loading = false;
      }
    },

    async carregarUnidades() {
      this.filtroUnidade = null;
      this.filtroEmail = null;
      this.unidades = [];
      this.emails = [];

      if (!this.filtroServidor) return;

      this.loading = true;
      try {
        const { data } = await axios.get("/api/dashboard/botpress/unidades", {
          params: { nome_server: this.filtroServidor },
        });
        this.unidades = data.map((u) => ({ value: u, text: u }));
      } catch (err) {
        console.error("Erro ao carregar unidades:", err);
      } finally {
        this.loading = false;
      }
    },

    async carregarEmails() {
      this.filtroEmail = null;
      this.emails = [];

      if (!this.filtroServidor || !this.filtroUnidade) return;

      this.loading = true;
      try {
        const { data } = await axios.get("/api/dashboard/botpress/emails", {
          params: {
            nome_server: this.filtroServidor,
            nome_unidade: this.filtroUnidade,
          },
        });
        this.emails = data.map((e) => ({ value: e, text: e }));
      } catch (err) {
        console.error("Erro ao carregar e-mails:", err);
      } finally {
        this.loading = false;
      }
    },

    async getConversas() {
      this.loading = true;
      try {
        const { data } = await axios.get("/api/dashboard/botpress/conversas", {
          params: {
            nome_server: this.filtroServidor,
            nome_unidade: this.filtroUnidade,
            email_usuario: this.filtroEmail,
            data_inicio: this.filtroDataInicio,
            data_fim: this.filtroDataFim,
            page: this.page,
            per_page: this.perPage,
          },
        });

        this.conversas = data.data || data;
        this.pagination.total = data.total || this.conversas.length;
      } catch (err) {
        console.error("Erro ao buscar conversas:", err);
      } finally {
        this.loading = false;
      }
    },

    async exportarConversas() {
      try {
        const response = await axios.get(
          `/api/dashboard/botpress/export-conversas`,
          {
            params: {
              nome_server: this.filtroServidor,
              nome_unidade: this.filtroUnidade,
              email_usuario: this.filtroEmail,
              data_inicio: this.filtroDataInicio,
              data_fim: this.filtroDataFim
            }
          }
        );

        // A rota já retorna uma URL — basta abrir
        window.open(response.data, "_blank");

      } catch (e) {
        console.error("Erro ao exportar conversas:", e);
        this.$bvToast.toast("Erro ao exportar as conversas.", {
          title: "Erro",
          variant: "danger",
          solid: true
        });
      }
    },

    async exportarGrid() {
      
      try {
        const response = await axios.get(
          `/api/dashboard/botpress/export-grid`,
          {
            params: {
              nome_server: this.filtroServidor,
              nome_unidade: this.filtroUnidade,
              email_usuario: this.filtroEmail,
              data_inicio: this.filtroDataInicio,
              data_fim: this.filtroDataFim,
              page: this.page,
              per_page: this.perPage
            }
          }
        );

        // Backend retorna a URL do CSV
        window.open(response.data, "_blank");

      } catch (e) {
        console.error("Erro ao exportar grid:", e);
        this.$bvToast.toast("Erro ao exportar a grid.", {
          title: "Erro",
          variant: "danger",
          solid: true
        });
      }
    },

    abrirConversa(item) {
      this.$router.push({
        name: "VisualizarConversa",
        params: { conversation_id: item.conversation_id, conversation_id_suas: item.conversation_id_suas },
      });
    },

    formatarData(data) {
      if (!data) return "-";

      const d = new Date(data.replace(" ", "T") + "Z"); // força UTC → evita hora errada

      const dia = d.toLocaleDateString("pt-BR");
      const hora = d.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });

      return `${dia} ${hora}`;
    },
  },
  mounted() {
    this.carregarServidores();
    this.getConversas();
  },
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
</style>
